// extracted by mini-css-extract-plugin
export var rootDates = "sRkS";